export default {
      id: "time-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#time",
      toString: function () {
        return this.url;
      }
    }